import { render, staticRenderFns } from "./CambiarClave.vue?vue&type=template&id=7acd20ae"
import script from "./CambiarClave.vue?vue&type=script&lang=js"
export * from "./CambiarClave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports